const arcgisToGeojson = require('./arcgis-to-geojson');
const togeojson = require('./togeojson');
/**
 * @namespace
 * @description geojson数据转换组件
 * @alias G.utils.GeoJSONUtil
 */
let GeoJSONUtil = {};
GeoJSONUtil = Object.assign(GeoJSONUtil,{
     /**
     * kml转换为geojson
     * @method
     * @memberOf G.utils.GeoJSONUtil.prototype
     * @param doc {Object} xmlObject
     * @returns {Object} Geojson对象
     */   
    fromKml(doc) {
        return togeojson.kml(doc);
    },
     /**
     * gpx转换为geojson
     * @ignore
     * @method
     * @memberOf G.utils.GeoJSONUtil.prototype
     * @param doc {Object} xmlObject
     * @returns {Object} Geojson对象
     */   
    fromGpx(doc) {
        return togeojson.gpx(doc);
    },    
    /**
     * arcgis转换为geojson
     * @method
     * @memberOf G.utils.GeoJSONUtil.prototype
     * @param esrijson {Object} esrijson
     * @param [idAttribute] {String} id字段
     * @returns {Object} Geojson对象
     */
    fromArcgis(arcgisjson, idAttribute){
        return arcgisToGeojson.arcgisToGeoJSON(arcgisjson, idAttribute);
    },
    /**
     * arcgis转换为geojson
     * @method
     * @memberOf G.utils.GeoJSONUtil.prototype
     * @param geojson {Object} geojson
     * @param [idAttribute] {String} id字段
     * @returns {Object} esrijson/arcgisjson对象
     */
    toArcgis(geojson, idAttribute){
        return arcgisToGeojson.geojsonToArcGIS(geojson, idAttribute);       
    }    
    
});
module.exports = GeoJSONUtil;